export default "__VITE_ASSET__DW$B1$jz__"